import cmsPage from './Queries/cmsPage';
import cmsBlock from './Queries/cmsBlock';
import route from './Queries/route';
import productDetail from './Queries/productDetail';
import products from './Queries/products';
import relatedProduct from './Queries/relatedProduct';
import customer from './Queries/customer';
// import cart from './Queries/cart';
// import addProductsToCart from './Queries/addProductsToCart';
// import customerCart from './Queries/customerCart';
// import customerOrders from './Queries/customerOrders';

export default {
  cmsPage,
  cmsBlock,
  route,
  productDetail,
  products,
  relatedProduct,
  customer,
  // cart,
  // addProductsToCart,
  // customerCart,
  // customerOrders,
};
